module.exports = __webpack_public_path__ + "static/media/DSCN3373a.5028fc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/DSCN3373a.jpg
// module id = 167
// module chunks = 0